module.exports = __webpack_public_path__ + "0ecd5b5c3606bad08c6d205ad8858e05.svg";